import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MfaDomainRanking } from '../models/mfaDomainRanking';

@Component({
  template: `<div
    class="text-left text-nowrap text-overflow-ellipsis overflow-hidden"
  >
    <img
      src="https://www.google.com/s2/favicons?domain={{ data?.adDomain }}&sz=48"
      alt="{{data?.adDomain} Icon"
      onerror="this.src='/assets/icons/icon-72x72-grey.png'"
      class="mr-2 rounded"
      width="32"
    />

    <ng-container *ngIf="hasInsightsEnabled; else showDomainOnly">
      <a
        [routerLink]="[
          '/insight',
          'domains',
          data?.adDomain,
          'GLOBAL',
          'GLOBAL'
        ]"
      >
        {{ data?.adDomain }}
      </a>
    </ng-container>

    <ng-template #showDomainOnly>
      <a (click)="onClick()">{{ data?.adDomain }}</a>
    </ng-template>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DomainNameComponent extends DataWidgetComponent implements OnInit {
  @Input() data: MfaDomainRanking;

  hasInsightsEnabled: boolean = false;

  ngOnInit() {
    super.ngOnInit();
    this.hasInsightsEnabled = this.userService.domainEnabled();
  }

  onClick() {
    this.eventService.showPopupEvent.emit(true);
  }
}
